import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { Container, Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import { formatPartialDate } from 'Utility/date';
import DocumentCreationButton from 'Components/DocumentCreationButton';
import { uhdrsMotorRatingScale } from 'neuro-schemas';

const { calculateScore } = uhdrsMotorRatingScale;

const UHDRS = ({ documents, startEdit, view }: IOwnProps): React.JSX.Element => {
  return (
    <HistorySection
      headerText={<FormattedMessage id="motorFunctionHuntington.uhdrs" />}
      newButton={
        <DocumentCreationButton
          name="uhdrsMotorRatingScale"
          text={'motorFunctionHuntington.newUHDRS'}
          onClick={startEdit({}, 'uhdrsMotorRatingScale')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <Item xs={2}>
              <FormattedMessage id="general.date" />
            </Item>
            <Item xs={7}>
              <Container>
                <Item xs={3}>
                  <FormattedMessage id="motorFunctionHuntington.uhdrsScore" />
                </Item>
                <Item xs={9}>
                  <Container>
                    <Item xs={3}>
                      <FormattedMessage id="motorFunctionHuntington.uhdrsMotorDysarthria" />
                    </Item>
                    <Item xs={3} style={{ paddingRight: '2rem' }}>
                      <FormattedMessage id="motorFunctionHuntington.uhdrsMotorRetropulsionPullTest" />
                    </Item>
                    <Item xs={3}>
                      <FormattedMessage id="motorFunctionHuntington.uhdrsMotorGait" />
                    </Item>
                    <Item xs={3}>
                      <FormattedMessage id="motorFunctionHuntington.uhdrsMotorTandemWalking" />
                    </Item>
                  </Container>
                </Item>
              </Container>
            </Item>
          </>
        }
        contentFormat={d => (
          <>
            <Item xs={2}>{formatPartialDate(d.date)}</Item>
            <Item xs={7}>
              <Container>
                <Item xs={3}>{calculateScore(d) ?? '-'}</Item>
                <Item xs={9}>
                  <Container>
                    <Item xs={3}>{d.dysarthria ?? '-'}</Item>
                    <Item xs={3} style={{ paddingRight: '2rem' }}>
                      {d.retropulsionPullTest ?? '-'}
                    </Item>
                    <Item xs={3}>{d.gait ?? '-'}</Item>
                    <Item xs={3}>{d.tandemWalking ?? '-'}</Item>
                  </Container>
                </Item>
              </Container>
            </Item>
            <Item xs={3}>
              <HistoryRowControls document={d} startEdit={startEdit} view={view} />
            </Item>
          </>
        )}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'uhdrsMotorRatingScale'>[];
  startEdit: StartEdit;
  view?: IView;
}

export default UHDRS;
